import { useLocation, useNavigate } from "react-router-dom";
import packageJson from "./../../package.json"
import useAuth from "../providers/authProvider";

export function Menu() {
  const { role } = useAuth();
  let navigate = useNavigate();
  const { pathname } = useLocation();
  const routeChange = (path: string) => {
    navigate(path);
  }

  return (<div className="block vtmn-bg-background-secondary menu-nav">
    { ['READER', 'ADMIN'].indexOf(role) !== -1 && <div className={`menu-nav-block ${pathname.replace('/', '') === 'invoice' ? 'menu-nav-block-selected ' : ''}`} onClick={() => routeChange('/invoice')} style={{ borderTop: '1px solid #d9dde0' }}>
      <div><span style={{ fontSize: '30px', marginTop: '15px'}} className="vtmx-file-line" aria-hidden="true"></span></div>
      Invoice
    </div> }
    { ['ADMIN'].indexOf(role) !== -1 && <div className={`menu-nav-block ${pathname.replace('/', '') === 'escrow' ? 'menu-nav-block-selected ' : ''}`} onClick={() => routeChange('/escrow')} style={{ borderTop: '1px solid #d9dde0' }}>
      <div><span style={{ fontSize: '30px', marginTop: '15px'}} className="vtmx-file-fill" aria-hidden="true"></span></div>
      Escrow
    </div> }
    { ['READER', 'ADMIN'].indexOf(role) !== -1 && <div className={`menu-nav-block ${pathname.replace('/', '') === 'commission' ? 'menu-nav-block-selected ' : ''}`} onClick={() => routeChange('/commission')}>
      <div><span style={{ fontSize: '30px', marginTop: '15px'}} className="vtmx-money-euro-box-line" aria-hidden="true"></span></div>
      Commission
    </div> }
    { ['READER', 'ADMIN'].indexOf(role) !== -1 && <div className={`menu-nav-block ${pathname.replace('/', '') === 'producer' ? 'menu-nav-block-selected ' : ''}`} onClick={() => routeChange('/producer')}>
      <div><span style={{ fontSize: '30px', marginTop: '15px'}} className="vtmx-user-line" aria-hidden="true"></span></div>
      Producer
    </div> }
    { ['ADMIN'].indexOf(role) !== -1 && <div className={`menu-nav-block ${pathname.replace('/', '') === 'business' ? 'menu-nav-block-selected ' : ''}`} onClick={() => routeChange('/business')}>
      <div><span style={{ fontSize: '30px', marginTop: '15px'}} className="vtmx-line-chart-line" aria-hidden="true"></span></div>
      Business
    </div> }
    { ['ADMIN'].indexOf(role) !== -1 && <div className={`menu-nav-block ${pathname.replace('/', '') === 'user' ? 'menu-nav-block-selected ' : ''}`} onClick={() => routeChange('/user')}>
      <div><span style={{ fontSize: '30px', marginTop: '15px'}} className="vtmx-group-line" aria-hidden="true"></span></div>
      User
    </div> }
    <div className="vtmn-fixed vtmn-bottom-1 vtmn-left-5 vtmn-text-xs">
      {packageJson.version}
    </div>
  </div>)
}